import { render, staticRenderFns } from "./ai-customer-link.vue?vue&type=template&id=b586b3fa&"
import script from "./ai-customer-link.vue?vue&type=script&lang=js&"
export * from "./ai-customer-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports